import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';

import ClientAccounts from '../../../../components/portalComponents/clientAccounts';

import { getClientAccounts } from '../../../../redux/clients/clients.slice';
import { setPageTitle } from '../../../../redux/title/title.slice';

function PracticeClientAccounts() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { clientAccounts, loadingClientAccounts } = useSelector((state) => state.clients);

  const [isLatest, setIsLatest] = useState(true);

  useEffect(() => {
    dispatch(setPageTitle('Client Accounts'));
  }, [dispatch]);

  const handleFetchAccounts = useCallback(
    (payload) => {
      dispatch(getClientAccounts(payload));
    },
    [dispatch]
  );

  const handleNavigate = useCallback(
    (accountId) => {
      navigate(`/practice/client/account/${accountId}`);
    },
    [navigate]
  );

  // -------------------------------
  // accounts normalization
  // -------------------------------
  const accounts = useMemo(() => {
    if (!clientAccounts) return [];
    if (Array.isArray(clientAccounts)) return clientAccounts;
    return clientAccounts.accounts || [];
  }, [clientAccounts]);

  const navTotal = useMemo(() => {
    if (!clientAccounts || Array.isArray(clientAccounts)) return 0;
    return clientAccounts.navTotal ?? 0;
  }, [clientAccounts]);

  return (
    <Box width="100%">
      <ClientAccounts
        clientAccounts={accounts}
        navTotal={navTotal}
        loading={loadingClientAccounts}
        clientId={id}
        onFetchAccounts={handleFetchAccounts}
        onNavigate={handleNavigate}
        isLatest={isLatest}
        setIsLatest={setIsLatest}
      />
    </Box>
  );
}

export default PracticeClientAccounts;
